import { ButtonBase, Icon } from '@material-ui/core';
import { PageHeader } from '../../../../components';
import CounterTabs from './CounterTabs';
import { AuctionTabs } from '../../../../components/AuctionTabs';
import { useScreen } from 'usehooks-ts';
import { useDispatch, useSelector } from 'react-redux';
import { setFilters } from '../../../../services/byMids/myBidsSlice';

const Header = () => {
  const { width } = useScreen();
  const isMobile = width < 567;

  const dispatch = useDispatch();

  const { filters } = useSelector(state => state.myBids);

  const selectTab = tab =>
    dispatch(
      setFilters({
        auctionType: tab,
        auctionStatus: 'active'
      })
    );

  return (
    <PageHeader>
      <AuctionTabs
        paddings={isMobile ? 'md' : 'lg'}
        fontSize={isMobile ? 'md' : 'lg'}
        selectTab={selectTab}
        selectedTab={filters.auctionType}
        hideNonActive
      />
      <span className="flex-grow" />
      <ButtonBase onClick={() => {}}>
        <Icon>refresh</Icon>
      </ButtonBase>
    </PageHeader>
  );
};

export default Header;
